(function (global) {
  'use strict';

  var gl;

  function isPercentage(str) {
    return str[str.length - 1] === '%';
  }

  function loadConfig() {
    var canvas = document.createElement('canvas');
    gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    if (!gl) return null;

    var extensions = {};
    ['OES_texture_float', 'OES_texture_half_float', 'OES_texture_float_linear', 'OES_texture_half_float_linear']
      .forEach(function (name) {
        var ext = gl.getExtension(name);
        if (ext) extensions[name] = ext;
      });

    if (!extensions.OES_texture_float) return null;

    var configs = [];

    function createConfig(type, glType, arrayType) {
      var name = 'OES_texture_' + type;
      var nameLinear = name + '_linear';
      var linearSupport = nameLinear in extensions;
      return {
        type: glType,
        arrayType: arrayType,
        linearSupport: linearSupport,
        extensions: linearSupport ? [name, nameLinear] : [name]
      };
    }

    configs.push(createConfig('float', gl.FLOAT, Float32Array));
    if (extensions.OES_texture_half_float) {
      configs.push(createConfig('half_float', extensions.OES_texture_half_float.HALF_FLOAT_OES, null));
    }

    var texture = gl.createTexture();
    var framebuffer = gl.createFramebuffer();
    gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
    gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);

    var config = null;
    for (var i = 0; i < configs.length; i++) {
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 32, 32, 0, gl.RGBA, configs[i].type, null);
      gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);
      if (gl.checkFramebufferStatus(gl.FRAMEBUFFER) === gl.FRAMEBUFFER_COMPLETE) {
        config = configs[i];
        break;
      }
    }
    return config;
  }

  function createImageData(width, height) {
    try {
      return new ImageData(width, height);
    } catch (e) {
      return document.createElement('canvas').getContext('2d').createImageData(width, height);
    }
  }

  function translateBackgroundPosition(value) {
    var parts = value.split(' ');
    if (parts.length === 1) {
      switch (value) {
        case 'center': return ['50%', '50%'];
        case 'top':    return ['50%', '0'];
        case 'bottom': return ['50%', '100%'];
        case 'left':   return ['0', '50%'];
        case 'right':  return ['100%', '50%'];
        default:       return [value, '50%'];
      }
    } else {
      return parts.map(function (part) {
        switch (part) {
          case 'center': return '50%';
          case 'top':
          case 'left':   return '0';
          case 'right':
          case 'bottom': return '100%';
          default:       return part;
        }
      });
    }
  }

  function createProgram(vertexSource, fragmentSource) {
    function compileSource(type, source) {
      var shader = gl.createShader(type);
      gl.shaderSource(shader, source);
      gl.compileShader(shader);
      if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
        throw new Error('compile error: ' + gl.getShaderInfoLog(shader));
      }
      return shader;
    }
    var program = {};
    program.id = gl.createProgram();
    gl.attachShader(program.id, compileSource(gl.VERTEX_SHADER, vertexSource));
    gl.attachShader(program.id, compileSource(gl.FRAGMENT_SHADER, fragmentSource));
    gl.linkProgram(program.id);
    if (!gl.getProgramParameter(program.id, gl.LINK_STATUS)) {
      throw new Error('link error: ' + gl.getProgramInfoLog(program.id));
    }
    program.uniforms  = {};
    program.locations = {};
    gl.useProgram(program.id);
    gl.enableVertexAttribArray(0);
    var match, name, regex = /uniform (\w+) (\w+)/g, shaderCode = vertexSource + fragmentSource;
    while ((match = regex.exec(shaderCode)) != null) {
      name = match[2];
      program.locations[name] = gl.getUniformLocation(program.id, name);
    }
    return program;
  }

  function bindTexture(texture, unit) {
    gl.activeTexture(gl.TEXTURE0 + (unit || 0));
    gl.bindTexture(gl.TEXTURE_2D, texture);
  }

  function extractUrl(value) {
    if (!value) return null;
    var urlMatch = /url\(["']?([^"']*?)["']?\)/.exec(value);
    return urlMatch ? urlMatch[1] : null;
  }

  function isDataUri(url) {
    return /^data:/.test(url);
  }

  function bindPointerEvents(instance, dropAt) {
    function enabled() {
      return instance.visible && instance.running && instance.interactive;
    }
    function withinBounds(clientX, clientY) {
      var rect = instance.el.getBoundingClientRect();
      return clientX >= rect.left && clientX <= rect.right && clientY >= rect.top && clientY <= rect.bottom;
    }
    function handleMove(e) {
      if (!enabled() || !withinBounds(e.clientX, e.clientY)) return;
      dropAt(e, false);
    }
    function handleDown(e) {
      if (!enabled() || !withinBounds(e.clientX, e.clientY)) return;
      dropAt(e, true);
    }
    function handleTouchMove(e) {
      if (!enabled()) return;
      for (var i = 0; i < e.changedTouches.length; i++) {
        var t = e.changedTouches[i];
        if (withinBounds(t.clientX, t.clientY)) dropAt(t, false);
      }
    }
    function handleTouchStart(e) {
      if (!enabled()) return;
      for (var i = 0; i < e.changedTouches.length; i++) {
        var t = e.changedTouches[i];
        if (withinBounds(t.clientX, t.clientY)) dropAt(t, true);
      }
    }
    document.addEventListener('mousemove', handleMove, true);
    document.addEventListener('mousedown', handleDown, true);
    document.addEventListener('touchmove', handleTouchMove, true);
    document.addEventListener('touchstart', handleTouchStart, true);
    instance._pointerCleanup = function () {
      document.removeEventListener('mousemove', handleMove, true);
      document.removeEventListener('mousedown', handleDown, true);
      document.removeEventListener('touchmove', handleTouchMove, true);
      document.removeEventListener('touchstart', handleTouchStart, true);
    };
  }

  var style = document.createElement('style');
  style.textContent = '.ripples-effect { position: relative; z-index: 0; }';
  document.head.appendChild(style);

  var config = loadConfig();
  var transparentPixels = createImageData(32, 32);

  var SharedRippleMethods = {
    drawQuad: function () {
      gl.bindBuffer(gl.ARRAY_BUFFER, this.quad);
      gl.vertexAttribPointer(0, 2, gl.FLOAT, false, 0, 0);
      gl.drawArrays(gl.TRIANGLE_FAN, 0, 4);
    },
    computeTextureBoundaries: function () {
      var elStyle            = getComputedStyle(this.el);
      var backgroundSize     = elStyle.backgroundSize;
      var backgroundAttach   = elStyle.backgroundAttachment;
      var backgroundPosition = translateBackgroundPosition(elStyle.backgroundPosition);
      var container;
      if (backgroundAttach === 'fixed') {
        container = { left: window.pageXOffset, top: window.pageYOffset, width: window.innerWidth, height: window.innerHeight };
      } else {
        var r = this.el.getBoundingClientRect();
        container = { left: r.left + window.pageXOffset, top: r.top + window.pageYOffset, width: this.el.clientWidth, height: this.el.clientHeight };
      }
      var bw, bh;
      if (backgroundSize === 'cover') {
        var s = Math.max(container.width / this.backgroundWidth, container.height / this.backgroundHeight);
        bw = this.backgroundWidth * s; bh = this.backgroundHeight * s;
      } else if (backgroundSize === 'contain') {
        var s = Math.min(container.width / this.backgroundWidth, container.height / this.backgroundHeight);
        bw = this.backgroundWidth * s; bh = this.backgroundHeight * s;
      } else {
        var p = backgroundSize.split(' ');
        bw = p[0] || ''; bh = p[1] || bw;
        if (isPercentage(bw))    bw = container.width  * parseFloat(bw)  / 100; else if (bw  !== 'auto') bw  = parseFloat(bw);
        if (isPercentage(bh))    bh = container.height * parseFloat(bh)  / 100; else if (bh  !== 'auto') bh  = parseFloat(bh);
        if (bw === 'auto' && bh === 'auto') { bw = this.backgroundWidth; bh = this.backgroundHeight; }
        else { if (bw === 'auto') bw = this.backgroundWidth * (bh / this.backgroundHeight); if (bh === 'auto') bh = this.backgroundHeight * (bw / this.backgroundWidth); }
      }
      var bx = backgroundPosition[0], by = backgroundPosition[1];
      bx = isPercentage(bx) ? container.left + (container.width  - bw) * parseFloat(bx) / 100 : container.left + parseFloat(bx);
      by = isPercentage(by) ? container.top  + (container.height - bh) * parseFloat(by) / 100 : container.top  + parseFloat(by);
      var er = this.el.getBoundingClientRect();
      var el = er.left + window.pageXOffset, et = er.top + window.pageYOffset;
      this.renderProgram.uniforms.topLeft      = new Float32Array([(el - bx) / bw, (et - by) / bh]);
      this.renderProgram.uniforms.bottomRight  = new Float32Array([this.renderProgram.uniforms.topLeft[0] + this.el.clientWidth / bw, this.renderProgram.uniforms.topLeft[1] + this.el.clientHeight / bh]);
      var ms = Math.max(this.canvas.width, this.canvas.height);
      this.renderProgram.uniforms.containerRatio = new Float32Array([this.canvas.width / ms, this.canvas.height / ms]);
    },
    hideCssBackground: function () {
      var inline = this.el.style.backgroundImage;
      if (inline === 'none') return;
      this.originalInlineCss = inline;
      this.originalCssBackgroundImage = getComputedStyle(this.el).backgroundImage;
      this.el.style.backgroundImage = 'none';
    },
    restoreCssBackground: function () { this.el.style.backgroundImage = this.originalInlineCss || ''; },
    updateSize: function () {
      var nw = this.el.clientWidth, nh = this.el.clientHeight;
      if (nw !== this.canvas.width || nh !== this.canvas.height) { this.canvas.width = nw; this.canvas.height = nh; }
    },
    destroy: function () {
      gl = null;
      window.removeEventListener('resize', this.updateSize);
      if (this._pointerCleanup) this._pointerCleanup();
      this.canvas.remove();
      this.el.classList.remove('ripples-effect');
      this.el._ripples = null;
      this.restoreCssBackground();
      this.destroyed = true;
    }
  };

  // ===========================================================================
  // WATER RIPPLE MODE
  // Standard WebGL wave-physics ripple — unchanged from sirxemic original
  // ===========================================================================

  var WaterRipples = function (el, options) {
    var that = this;

    this.el           = el;
    this.interactive  = options.interactive;
    this.resolution   = options.resolution;
    this.textureDelta = new Float32Array([1 / this.resolution, 1 / this.resolution]);
    this.perturbance  = options.perturbance;
    this.dropRadius   = options.dropRadius;
    this.crossOrigin  = options.crossOrigin;
    this.imageUrl     = options.imageUrl;

    var canvas = document.createElement('canvas');
    canvas.width  = el.clientWidth;
    canvas.height = el.clientHeight;
    this.canvas = canvas;
    canvas.style.cssText = 'position:absolute;left:0;top:0;right:0;bottom:0;z-index:-1;';

    el.classList.add('ripples-effect');
    el.appendChild(canvas);

    this.context = gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    config.extensions.forEach(function (name) { gl.getExtension(name); });

    this.updateSize = this.updateSize.bind(this);
    window.addEventListener('resize', this.updateSize);

    this.textures         = [];
    this.framebuffers     = [];
    this.bufferWriteIndex = 0;
    this.bufferReadIndex  = 1;

    var arrayType   = config.arrayType;
    var textureData = arrayType ? new arrayType(this.resolution * this.resolution * 4) : null;

    for (var i = 0; i < 2; i++) {
      var texture     = gl.createTexture();
      var framebuffer = gl.createFramebuffer();
      gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
      gl.bindTexture(gl.TEXTURE_2D, texture);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, config.linearSupport ? gl.LINEAR : gl.NEAREST);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, config.linearSupport ? gl.LINEAR : gl.NEAREST);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, this.resolution, this.resolution, 0, gl.RGBA, config.type, textureData);
      gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);
      this.textures.push(texture);
      this.framebuffers.push(framebuffer);
    }

    this.quad = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, this.quad);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1,-1,+1,-1,+1,+1,-1,+1]), gl.STATIC_DRAW);

    this.initShaders();
    this.initTexture();
    this.setTransparentTexture();
    this.loadImage();

    gl.clearColor(0, 0, 0, 0);
    gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);

    this.visible   = true;
    this.running   = true;
    this.destroyed = false;

    this.setupPointerEvents();

    function step() {
      if (!that.destroyed) { that.step(); requestAnimationFrame(step); }
    }
    requestAnimationFrame(step);
  };

  WaterRipples.DEFAULTS = {
    imageUrl:    null,
    resolution:  256,
    dropRadius:  20,
    perturbance: 0.03,
    interactive: true,
    crossOrigin: ''
  };

  WaterRipples.prototype = {
    setupPointerEvents: function () {
      var that = this;
      bindPointerEvents(this, function (p, big) {
        that.dropAtPointer(p, that.dropRadius * (big ? 1.5 : 1), big ? 0.14 : 0.01);
      });
    },
    loadImage: function () {
      var that = this;
      gl = this.context;
      var src = this.imageUrl || extractUrl(this.originalCssBackgroundImage) || extractUrl(getComputedStyle(this.el).backgroundImage);
      if (src === this.imageSource) return;
      this.imageSource = src;
      if (!src) { this.setTransparentTexture(); return; }
      var img = new Image();
      img.onload = function () {
        gl = that.context;
        gl.bindTexture(gl.TEXTURE_2D, that.backgroundTexture);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, img);
        that.backgroundWidth  = img.width;
        that.backgroundHeight = img.height;
        that.hideCssBackground();
      };
      img.onerror = function () { gl = that.context; that.setTransparentTexture(); };
      img.crossOrigin = isDataUri(src) ? null : this.crossOrigin;
      img.src = src;
    },
    step: function () {
      gl = this.context;
      if (!this.visible) return;
      this.computeTextureBoundaries();
      if (this.running) this.update();
      this.render();
    },
    render: function () {
      gl.bindFramebuffer(gl.FRAMEBUFFER, null);
      gl.viewport(0, 0, this.canvas.width, this.canvas.height);
      gl.enable(gl.BLEND);
      gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
      gl.useProgram(this.renderProgram.id);
      bindTexture(this.backgroundTexture, 0);
      bindTexture(this.textures[0], 1);
      gl.uniform1f(this.renderProgram.locations.perturbance, this.perturbance);
      gl.uniform2fv(this.renderProgram.locations.topLeft, this.renderProgram.uniforms.topLeft);
      gl.uniform2fv(this.renderProgram.locations.bottomRight, this.renderProgram.uniforms.bottomRight);
      gl.uniform2fv(this.renderProgram.locations.containerRatio, this.renderProgram.uniforms.containerRatio);
      gl.uniform1i(this.renderProgram.locations.samplerBackground, 0);
      gl.uniform1i(this.renderProgram.locations.samplerRipples, 1);
      this.drawQuad();
      gl.disable(gl.BLEND);
    },
    update: function () {
      gl.viewport(0, 0, this.resolution, this.resolution);
      gl.bindFramebuffer(gl.FRAMEBUFFER, this.framebuffers[this.bufferWriteIndex]);
      bindTexture(this.textures[this.bufferReadIndex]);
      gl.useProgram(this.updateProgram.id);
      this.drawQuad();
      this.swapBufferIndices();
    },
    swapBufferIndices: function () {
      this.bufferWriteIndex = 1 - this.bufferWriteIndex;
      this.bufferReadIndex  = 1 - this.bufferReadIndex;
    },
    initShaders: function () {
      var vert = ['attribute vec2 vertex;','varying vec2 coord;','void main() {','  coord = vertex * 0.5 + 0.5;','  gl_Position = vec4(vertex, 0.0, 1.0);','}'].join('\n');
      this.dropProgram = createProgram(vert, [
        'precision highp float;','const float PI = 3.141592653589793;',
        'uniform sampler2D texture;','uniform vec2 center;','uniform float radius;','uniform float strength;','varying vec2 coord;',
        'void main() {','  vec4 info = texture2D(texture, coord);',
        '  float drop = max(0.0, 1.0 - length(center * 0.5 + 0.5 - coord) / radius);',
        '  drop = 0.5 - cos(drop * PI) * 0.5;','  info.r += drop * strength;','  gl_FragColor = info;','}'
      ].join('\n'));
      this.updateProgram = createProgram(vert, [
        'precision highp float;','uniform sampler2D texture;','uniform vec2 delta;','varying vec2 coord;',
        'void main() {','  vec4 info = texture2D(texture, coord);',
        '  vec2 dx = vec2(delta.x, 0.0);','  vec2 dy = vec2(0.0, delta.y);',
        '  float average = (texture2D(texture, coord - dx).r + texture2D(texture, coord - dy).r + texture2D(texture, coord + dx).r + texture2D(texture, coord + dy).r) * 0.25;',
        '  info.g += (average - info.r) * 2.0;','  info.g *= 0.995;','  info.r += info.g;','  gl_FragColor = info;','}'
      ].join('\n'));
      gl.uniform2fv(this.updateProgram.locations.delta, this.textureDelta);
      this.renderProgram = createProgram([
        'precision highp float;','attribute vec2 vertex;',
        'uniform vec2 topLeft;','uniform vec2 bottomRight;','uniform vec2 containerRatio;',
        'varying vec2 ripplesCoord;','varying vec2 backgroundCoord;',
        'void main() {',
        '  backgroundCoord = mix(topLeft, bottomRight, vertex * 0.5 + 0.5);',
        '  backgroundCoord.y = 1.0 - backgroundCoord.y;',
        '  ripplesCoord = vec2(vertex.x, -vertex.y) * containerRatio * 0.5 + 0.5;',
        '  gl_Position = vec4(vertex.x, -vertex.y, 0.0, 1.0);','}'
      ].join('\n'), [
        'precision highp float;',
        'uniform sampler2D samplerBackground;','uniform sampler2D samplerRipples;',
        'uniform vec2 delta;','uniform float perturbance;',
        'varying vec2 ripplesCoord;','varying vec2 backgroundCoord;',
        'void main() {',
        '  float height  = texture2D(samplerRipples, ripplesCoord).r;',
        '  float heightX = texture2D(samplerRipples, vec2(ripplesCoord.x + delta.x, ripplesCoord.y)).r;',
        '  float heightY = texture2D(samplerRipples, vec2(ripplesCoord.x, ripplesCoord.y + delta.y)).r;',
        '  vec3 dx = vec3(delta.x, heightX - height, 0.0);',
        '  vec3 dy = vec3(0.0, heightY - height, delta.y);',
        '  vec2 offset = -normalize(cross(dy, dx)).xz;',
        '  float specular = pow(max(0.0, dot(offset, normalize(vec2(-0.6, 1.0)))), 4.0);',
        '  vec2 sampleCoord = clamp(backgroundCoord + offset * perturbance, 0.0, 1.0);',
        '  gl_FragColor = texture2D(samplerBackground, sampleCoord) + specular;','}'
      ].join('\n'));
      gl.uniform2fv(this.renderProgram.locations.delta, this.textureDelta);
    },
    initTexture: function () {
      this.backgroundTexture = gl.createTexture();
      gl.bindTexture(gl.TEXTURE_2D, this.backgroundTexture);
      gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, 1);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    },
    setTransparentTexture: function () {
      gl.bindTexture(gl.TEXTURE_2D, this.backgroundTexture);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, transparentPixels);
    },
    dropAtPointer: function (pointer, radius, strength) {
      var rect  = this.el.getBoundingClientRect();
      var bleft = parseInt(getComputedStyle(this.el).borderLeftWidth) || 0;
      var btop  = parseInt(getComputedStyle(this.el).borderTopWidth)  || 0;
      var cx    = pointer.clientX !== undefined ? pointer.clientX : pointer.pageX - window.pageXOffset;
      var cy    = pointer.clientY !== undefined ? pointer.clientY : pointer.pageY - window.pageYOffset;
      this.drop(cx - rect.left - bleft, cy - rect.top - btop, radius, strength);
    },
    drop: function (x, y, radius, strength) {
      gl = this.context;
      var ew = this.el.clientWidth, eh = this.el.clientHeight, ls = Math.max(ew, eh);
      radius = radius / ls;
      var pos = new Float32Array([(2 * x - ew) / ls, (eh - 2 * y) / ls]);
      gl.viewport(0, 0, this.resolution, this.resolution);
      gl.bindFramebuffer(gl.FRAMEBUFFER, this.framebuffers[this.bufferWriteIndex]);
      bindTexture(this.textures[this.bufferReadIndex]);
      gl.useProgram(this.dropProgram.id);
      gl.uniform2fv(this.dropProgram.locations.center, pos);
      gl.uniform1f(this.dropProgram.locations.radius, radius);
      gl.uniform1f(this.dropProgram.locations.strength, strength);
      this.drawQuad();
      this.swapBufferIndices();
    },
    show: function () { this.visible = true;  this.canvas.style.display = ''; this.hideCssBackground(); },
    hide: function () { this.visible = false; this.canvas.style.display = 'none'; this.restoreCssBackground(); },
    pause: function () { this.running = false; },
    play:  function () { this.running = true; },
    set: function (property, value) {
      switch (property) {
        case 'dropRadius': case 'perturbance': case 'interactive': case 'crossOrigin': this[property] = value; break;
        case 'imageUrl': this.imageUrl = value; this.loadImage(); break;
      }
    }
  };

  Object.assign(WaterRipples.prototype, SharedRippleMethods);

  // ===========================================================================
  // HEAT HAZE MODE
  //
  // Completely different approach — no wave physics at all.
  // The render shader drives everything using layered sine functions to produce
  // slow, drifting horizontal bands of vertical displacement, exactly what you
  // see looking at a hot road or desert horizon.
  //
  // A single uniform `uTime` is incremented each frame and passed into the
  // fragment shader. No simulation buffer, no drops, no pointer interaction.
  // ===========================================================================

  var HeatHaze = function (el, options) {
    var that = this;

    this.el           = el;
    this.crossOrigin  = options.crossOrigin;
    this.imageUrl     = options.imageUrl;
    this.interactive  = options.interactive;
    this.perturbance  = options.perturbance;
    this.resolution   = options.resolution;
    this.dropRadius   = options.dropRadius;
    this.textureDelta = new Float32Array([1 / this.resolution, 1 / this.resolution]);
    this.time         = 0.0;

    var canvas = document.createElement('canvas');
    canvas.width  = el.clientWidth;
    canvas.height = el.clientHeight;
    this.canvas = canvas;
    canvas.style.cssText = 'position:absolute;left:0;top:0;right:0;bottom:0;z-index:-1;';

    el.classList.add('ripples-effect');
    el.appendChild(canvas);

    this.context = gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    config.extensions.forEach(function (name) { gl.getExtension(name); });

    this.updateSize = this.updateSize.bind(this);
    window.addEventListener('resize', this.updateSize);

    // Wave simulation buffers — same as WaterRipples
    this.textures         = [];
    this.framebuffers     = [];
    this.bufferWriteIndex = 0;
    this.bufferReadIndex  = 1;

    var arrayType   = config.arrayType;
    var textureData = arrayType ? new arrayType(this.resolution * this.resolution * 4) : null;

    for (var i = 0; i < 2; i++) {
      var texture     = gl.createTexture();
      var framebuffer = gl.createFramebuffer();
      gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
      gl.bindTexture(gl.TEXTURE_2D, texture);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, config.linearSupport ? gl.LINEAR : gl.NEAREST);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, config.linearSupport ? gl.LINEAR : gl.NEAREST);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, this.resolution, this.resolution, 0, gl.RGBA, config.type, textureData);
      gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);
      this.textures.push(texture);
      this.framebuffers.push(framebuffer);
    }

    this.quad = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, this.quad);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1,-1,+1,-1,+1,+1,-1,+1]), gl.STATIC_DRAW);

    this.initShaders();
    this.initTexture();
    this.loadImage();

    gl.clearColor(0, 0, 0, 0);
    this.visible   = true;
    this.running   = true;
    this.destroyed = false;

    this.setupPointerEvents();

    function step() {
      if (!that.destroyed) { that.step(); requestAnimationFrame(step); }
    }
    requestAnimationFrame(step);
  };

  HeatHaze.DEFAULTS = {
    imageUrl:    null,
    resolution:  256,
    dropRadius:  20,
    perturbance: 0.006,
    crossOrigin: ''
  };

  HeatHaze.prototype = {
    setupPointerEvents: function () {
      var that = this;
      bindPointerEvents(this, function (p, big) {
        var rect = that.el.getBoundingClientRect();
        var x = p.clientX - rect.left;
        var y = p.clientY - rect.top;
        that.drop(x, y, that.dropRadius * (big ? 1.5 : 1), big ? 0.1 : 0.01);
      });
    },

    initShaders: function () {
      gl = this.context;

      var vert = [
        'attribute vec2 vertex;',
        'varying vec2 coord;',
        'void main() {',
        '  coord = vertex * 0.5 + 0.5;',
        '  gl_Position = vec4(vertex, 0.0, 1.0);',
        '}'
      ].join('\n');

      // Drop program — identical to WaterRipples, injects energy into the sim buffer
      this.dropProgram = createProgram(vert, [
        'precision highp float;',
        'const float PI = 3.141592653589793;',
        'uniform sampler2D texture;',
        'uniform vec2 center;',
        'uniform float radius;',
        'uniform float strength;',
        'varying vec2 coord;',
        'void main() {',
        '  vec4 info = texture2D(texture, coord);',
        '  float drop = max(0.0, 1.0 - length(center * 0.5 + 0.5 - coord) / radius);',
        '  drop = 0.5 - cos(drop * PI) * 0.5;',
        '  info.r += drop * strength;',
        '  gl_FragColor = info;',
        '}'
      ].join('\n'));

      // Update program — identical to WaterRipples, propagates the wave each frame
      this.updateProgram = createProgram(vert, [
        'precision highp float;',
        'uniform sampler2D texture;',
        'uniform vec2 delta;',
        'varying vec2 coord;',
        'void main() {',
        '  vec4 info = texture2D(texture, coord);',
        '  vec2 dx = vec2(delta.x, 0.0);',
        '  vec2 dy = vec2(0.0, delta.y);',
        '  float average = (texture2D(texture, coord - dx).r + texture2D(texture, coord - dy).r + texture2D(texture, coord + dx).r + texture2D(texture, coord + dy).r) * 0.25;',
        '  info.g += (average - info.r) * 2.0;',
        '  info.g *= 0.995;',
        '  info.r += info.g;',
        '  gl_FragColor = info;',
        '}'
      ].join('\n'));
      gl.uniform2fv(this.updateProgram.locations.delta, this.textureDelta);

      // Render program — haze version.
      // Samples the wave sim buffer (samplerRipples) for mouse-driven displacement,
      // then adds the ambient sine-band haze on top. Both are Y-axis only.
      this.renderProgram = createProgram([
        'precision highp float;',
        'attribute vec2 vertex;',
        'uniform vec2 topLeft;',
        'uniform vec2 bottomRight;',
        'uniform vec2 containerRatio;',
        'varying vec2 ripplesCoord;',
        'varying vec2 backgroundCoord;',
        'void main() {',
        '  backgroundCoord = mix(topLeft, bottomRight, vertex * 0.5 + 0.5);',
        '  backgroundCoord.y = 1.0 - backgroundCoord.y;',
        '  ripplesCoord = vec2(vertex.x, -vertex.y) * containerRatio * 0.5 + 0.5;',
        '  gl_Position = vec4(vertex.x, -vertex.y, 0.0, 1.0);',
        '}'
      ].join('\n'), [
        'precision highp float;',
        'uniform sampler2D uTexture;',
        'uniform sampler2D samplerRipples;',
        'uniform vec2 delta;',
        'uniform float uTime;',
        'uniform float uStrength;',
        'varying vec2 ripplesCoord;',
        'varying vec2 backgroundCoord;',

        'void main() {',
        // --- Mouse-driven displacement from wave sim (Y only) ---
        '  float height  = texture2D(samplerRipples, ripplesCoord).r;',
        '  float heightY = texture2D(samplerRipples, vec2(ripplesCoord.x, ripplesCoord.y + delta.y)).r;',
        '  float rippleOffset = (heightY - height) * uStrength * 80.0;',

        // --- Ambient haze bands (Y only) ---
        '  float y = 1.0 - ripplesCoord.y;',
        '  float falloff = pow(1.0 - y, 2.5);',
        '  float b1 = sin(ripplesCoord.y * 120.0 + uTime * 0.7  + ripplesCoord.x * 3.1) * 0.55;',
        '  float b2 = sin(ripplesCoord.y *  74.0 + uTime * 1.1  + ripplesCoord.x * 1.7) * 0.30;',
        '  float b3 = sin(ripplesCoord.y * 210.0 + uTime * 0.45 + ripplesCoord.x * 5.3) * 0.15;',
        '  float hazeOffset = (b1 + b2 + b3) * uStrength * falloff;',

        '  vec2 distortedUv = vec2(backgroundCoord.x, backgroundCoord.y + rippleOffset + hazeOffset);',
        '  gl_FragColor = texture2D(uTexture, distortedUv);',
        '}'
      ].join('\n'));
      gl.uniform2fv(this.renderProgram.locations.delta, this.textureDelta);
    },

    initTexture: function () {
      gl = this.context;
      this.backgroundTexture = gl.createTexture();
      gl.bindTexture(gl.TEXTURE_2D, this.backgroundTexture);
      gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, 1);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, transparentPixels);
    },

    loadImage: function () {
      var that = this;
      gl = this.context;
      var src = this.imageUrl || extractUrl(this.originalCssBackgroundImage) || extractUrl(getComputedStyle(this.el).backgroundImage);
      if (src === this.imageSource) return;
      this.imageSource = src;
      if (!src) return;
      var img = new Image();
      img.onload = function () {
        gl = that.context;
        gl.bindTexture(gl.TEXTURE_2D, that.backgroundTexture);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, img);
        that.backgroundWidth  = img.width;
        that.backgroundHeight = img.height;
        that.hideCssBackground();
      };
      img.onerror = function () {};
      img.crossOrigin = isDataUri(src) ? null : this.crossOrigin;
      img.src = src;
    },

step: function () {
  gl = this.context;
  if (!this.visible) return;
  if (this.running) {
    this.time += 0.016;
    this.updateWave();
  }
  // Only compute boundaries once we have image dimensions
  if (this.backgroundWidth && this.backgroundHeight) {
    this.computeTextureBoundaries();
  }
  this.render();
},

    updateWave: function () {
      gl.viewport(0, 0, this.resolution, this.resolution);
      gl.bindFramebuffer(gl.FRAMEBUFFER, this.framebuffers[this.bufferWriteIndex]);
      bindTexture(this.textures[this.bufferReadIndex]);
      gl.useProgram(this.updateProgram.id);
      this.drawQuad();
      this.bufferWriteIndex = 1 - this.bufferWriteIndex;
      this.bufferReadIndex  = 1 - this.bufferReadIndex;
    },

render: function () {
  gl.bindFramebuffer(gl.FRAMEBUFFER, null);
  gl.viewport(0, 0, this.canvas.width, this.canvas.height);
  gl.clear(gl.COLOR_BUFFER_BIT);
  gl.useProgram(this.renderProgram.id);
  gl.bindBuffer(gl.ARRAY_BUFFER, this.quad);
  gl.vertexAttribPointer(0, 2, gl.FLOAT, false, 0, 0);
  bindTexture(this.backgroundTexture, 0);
  bindTexture(this.textures[this.bufferReadIndex], 1);
  gl.uniform1i(this.renderProgram.locations.uTexture, 0);
  gl.uniform1i(this.renderProgram.locations.samplerRipples, 1);
  gl.uniform1f(this.renderProgram.locations.uTime, this.time);
  gl.uniform1f(this.renderProgram.locations.uStrength, this.perturbance);
  if (this.renderProgram.uniforms.topLeft) {
    gl.uniform2fv(this.renderProgram.locations.topLeft, this.renderProgram.uniforms.topLeft);
    gl.uniform2fv(this.renderProgram.locations.bottomRight, this.renderProgram.uniforms.bottomRight);
    gl.uniform2fv(this.renderProgram.locations.containerRatio, this.renderProgram.uniforms.containerRatio);
  }
  gl.drawArrays(gl.TRIANGLE_FAN, 0, 4);
},

    drop: function (x, y, radius, strength) {
      gl = this.context;
      var ew = this.el.clientWidth, eh = this.el.clientHeight, ls = Math.max(ew, eh);
      var pos = new Float32Array([(2 * x - ew) / ls, (eh - 2 * y) / ls]);
      gl.viewport(0, 0, this.resolution, this.resolution);
      gl.bindFramebuffer(gl.FRAMEBUFFER, this.framebuffers[this.bufferWriteIndex]);
      bindTexture(this.textures[this.bufferReadIndex]);
      gl.useProgram(this.dropProgram.id);
      gl.uniform2fv(this.dropProgram.locations.center, pos);
      gl.uniform1f(this.dropProgram.locations.radius, radius / ls);
      gl.uniform1f(this.dropProgram.locations.strength, strength);
      this.drawQuad();
      this.bufferWriteIndex = 1 - this.bufferWriteIndex;
      this.bufferReadIndex  = 1 - this.bufferReadIndex;
    },

    show:  function () { this.visible = true;  this.canvas.style.display = ''; this.hideCssBackground(); },
    hide:  function () { this.visible = false; this.canvas.style.display = 'none'; this.restoreCssBackground(); },
    pause: function () { this.running = false; },
    play:  function () { this.running = true; },
    set: function (property, value) {
      if (property === 'perturbance') this.perturbance = value;
      if (property === 'dropRadius')  this.dropRadius  = value;
      if (property === 'interactive') this.interactive = value;
      if (property === 'crossOrigin') this.crossOrigin = value;
      if (property === 'imageUrl')    { this.imageUrl = value; this.loadImage(); }
    }
  };

  Object.assign(HeatHaze.prototype, SharedRippleMethods);

  // ===========================================================================
  // Public API
  // ===========================================================================

  function initRipples(el, options) {
    if (!config) throw new Error('Your browser does not support WebGL or the OES_texture_float extension.');
    if (el._ripples) return el._ripples;
    var effect = (options && options.effect) || 'water';
    if (effect === 'haze') {
      var opts = Object.assign({}, HeatHaze.DEFAULTS, options);
      el._ripples = new HeatHaze(el, opts);
    } else {
      var opts = Object.assign({}, WaterRipples.DEFAULTS, options);
      el._ripples = new WaterRipples(el, opts);
    }
    return el._ripples;
  }

  function callRipples(el, method) {
    var instance = el._ripples;
    if (!instance) return;
    var args = Array.prototype.slice.call(arguments, 2);
    return instance[method].apply(instance, args);
  }

  global.Ripples = { init: initRipples, call: callRipples };

  // ===========================================================================
  // Custom element
  // ===========================================================================

  if (!customElements.get('vbb-water-ripple')) {
    customElements.define('vbb-water-ripple', class VBBWaterRipple extends HTMLElement {
      constructor() {
        super();
        this._resizeTimer = null;
        this._resolution  = parseInt(this.getAttribute('data-ripple-resolution')) || 512;
        this._dropRadius  = parseInt(this.getAttribute('data-drop-radius'))        || 50;
        this._perturbance = parseFloat(this.getAttribute('data-perturbance'))      || 0.01;
        this._interactive = this.getAttribute('data-interactive') !== 'false';
        this._effect      = this.getAttribute('data-effect') || 'water';
      }

      connectedCallback() {
        const init = () => this._initRipples();
        if (document.readyState === 'complete') {
          init();
        } else {
          window.addEventListener('load', init, { once: true });
        }
        window.addEventListener('resize', () => {
          clearTimeout(this._resizeTimer);
          this._resizeTimer = setTimeout(() => this._reInitRipples(), 200);
        });
      }

      disconnectedCallback() {
        try {
          callRipples(this, 'destroy');
        } catch (e) {
          console.warn('Ripples destroy failed:', e);
        }
        this._restoreSibling();
      }

      _hideSibling() {
        if (!this.parentElement) return;
        const media = this.parentElement.querySelector(':scope > picture, :scope > video, :scope > img');
        if (!media) return;
        this._hiddenSibling = media;
        media.style.visibility = 'hidden';
        media.style.pointerEvents = 'none';
      }

      _restoreSibling() {
        if (!this._hiddenSibling) return;
        this._hiddenSibling.style.visibility = '';
        this._hiddenSibling.style.pointerEvents = '';
        this._hiddenSibling = null;
      }

      _initRipples() {
        try {
          initRipples(this, {
            effect:      this._effect,
            resolution:  this._resolution,
            dropRadius:  this._dropRadius,
            perturbance: this._perturbance,
            interactive: this._interactive
          });
          this._hideSibling();
          console.log(`Ripples (${this._effect}) initialized on <vbb-water-ripple>`);
        } catch (e) {
          console.warn('Ripples failed to initialize:', e);
        }
      }

      _reInitRipples() {
        try {
          callRipples(this, 'destroy');
        } catch (e) {
          console.warn('Ripples destroy failed:', e);
        }
        this._initRipples();
      }
    });
  }

})(window);
